var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispatched({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "14px",
    viewBox: "0 0 21 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "megaphone@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dispatching",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dispatching-MVP",
    transform: "translate(-152.000000, -248.000000)",
    stroke: "#5E6D7B"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dispatched-label",
    transform: "translate(153.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "megaphone",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3438826,0.976050305 C11.0271906,0.976050305 11.5811212,3.14987639 11.5811212,5.83142676 C11.5811212,8.51297714 11.0271906,10.6868032 10.3438826,10.6868032 C9.66057467,10.6868032 9.10664411,8.51297714 9.10664411,5.83142676 C9.10664411,3.14987639 9.66057467,0.976050305 10.3438826,0.976050305 Z M3.34273539,8.05833765 L4.68697619,8.23542445 C4.68697619,8.57656825 5.06957844,8.57656825 5.06957844,8.91672494 C5.06957844,9.25905326 4.68697619,9.25905326 4.68697619,9.59960479 C4.68697619,9.94114343 5.06957844,9.94114343 5.06957844,10.2830769 C5.06957844,10.623431 4.68697619,10.623431 4.68697619,10.9643774 C4.68697619,11.3061135 5.06957844,11.3061135 5.06957844,11.6472573 C5.06957844,11.9108145 4.68697619,12.0798071 4.68697619,12.0798071 C4.68697619,12.0798071 3.79660668,12.5731626 3.37609957,12.3303345 C2.79074578,11.9915598 3.34273539,8.05833765 3.34273539,8.05833765 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1442898,1.0394225 C9.55557987,1.4141279 9.10664411,3.41637349 9.10664411,5.83142676 C9.10664411,8.51339347 9.66041052,10.6871981 10.3440801,10.6871981 C10.3440801,10.6871981 10.1823921,10.7179958 9.85921364,10.4844465 C8.83301836,9.74214288 6.95850427,8.00582362 2.67387244,8.00582362 C2.41189453,8.00582362 2.20025848,7.03372174 2.20025848,5.8345855 C2.19986419,4.634857 2.41169711,3.66216286 2.67367502,3.66216286 L2.67367502,3.65624022 C6.95791201,3.65624022 8.83597968,1.95229803 9.86335949,1.2099944 C9.97806119,1.12688009 10.0708491,1.07416863 10.1442898,1.0394225 Z M2.44782519,3.77429809 C2.29936446,4.18868514 2.19986419,4.95527157 2.19986419,5.83498034 C2.19986419,6.70916132 2.2987722,7.47160191 2.44565356,7.88677865 L2.44565356,7.88835802 L1.34680728,7.88835802 C0.602726857,7.88835802 0,6.96699338 0,5.83162418 C0,4.69586015 0.602924278,3.77429809 1.34680728,3.77429809 L2.44782519,3.77429809 Z M14.7126981,6.01502846 L18.5912346,6.01502846 M13.8213415,1.94282182 L14.5221867,3.44169138e-14 M13.8213415,10.0878274 L14.5221867,12.0306492 M14.4986936,4.14229116 L16.8306325,2.64425926 M14.4986936,7.88677865 L16.8365551,9.38954866",
    id: "Combined-Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatched);
export default __webpack_public_path__ + "static/media/dispatched.6150bb9984fc375d4175c728bd20d80c.svg";
export { ForwardRef as ReactComponent };